import IconError from '@bubble-ui/icon-error';
import baseAlertBanner from '@bubble-ui/temp-base-alert-banner';

/**
 * @deprecated this component is outdated and will be removed with v7.0.0. Use Toast with property status="error" instead.
 */
export default baseAlertBanner('AlertBannerError', 'error', IconError);
//# sourceMappingURL=index.js.map